import './social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InteractionContent extends Monitoring.Models.SocialContents.SocialContent

  initialize: (json) ->
    super(json)

  avatar: ->
    return @interaction().author.avatar

  userId: ->
    return @interaction().author.id

  userLink: ->
    return @interaction().author.link

  name: ->
    return @interaction().author.name

  username: ->
    return @interaction().author.username

  content: ->
    return @interaction().content

  created_at: ->
    return @interaction().created_at

  link: ->
    return @interaction().link

  contentUrl: ->
    return @link()

  content_id: ->
    return @interaction().content_id

  tweet_id: -> # TODO: borrar y reemplazar en todos lados donde se use tweet_id por content_id
    return @content_id()

  links: ->
    return @interaction().links

  mentions: ->
    return @interaction().mentions

  hashtags: ->
    return @interaction().hashtags
